import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { downloadCombinedStockReportApi } from "../../api/warehouse.api";

interface DownloadPayload {
  format: "csv" | "xlsx";
  date: string;
}

export const downloadCombinedStockReport = createAsyncThunk(
  "adminDashboard/downloadCombinedStockReport",
  async (payload: DownloadPayload, { rejectWithValue }) => {
    try {
      return await downloadCombinedStockReportApi(payload.format, payload.date);
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  },
);

// === STATE ===
interface AdminDashboardState {
  isDownloading: boolean;
}

const initialState: AdminDashboardState = {
  isDownloading: false,
};

// === SLICE ===
const adminDashboardSlice = createSlice({
  name: "adminDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadCombinedStockReport.pending, (state) => {
        state.isDownloading = true;
      })
      .addCase(downloadCombinedStockReport.fulfilled, (state) => {
        state.isDownloading = false;
      })
      .addCase(downloadCombinedStockReport.rejected, (state) => {
        state.isDownloading = false;
      });
  },
});

export default adminDashboardSlice.reducer;
